import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Import components
import TileContainerView from './TileContainerView';
import TileController from '../Tile/TileController';
import DoubleTileController from '../DoubleTile/DoubleTileController';

import { fetchTiles } from '../../../Base/Actions/index';
import { getBreakpoint } from '../../../Base/Breakpoints';
import NewsletterTileView from '../NewsletterTile/NewsletterTileView';
import ShopTileView from '../ShopTile/ShopTileView';
import HeroTileView from '../HeroTile/HeroTileView';

class TileContainerController extends React.Component {
  static makeTileObjects(tilesData) {
    if (!tilesData) {
      return [];
    }

    return tilesData.map(
      (tile, index) => {
        const key = tile.id || index;
        // small tiles with half height as "normal" tiles
        if (tile.size === 0.5 && tilesData.length > index + 1) {
          // include the next tile, which is also small after sorting
          const secondTile = tilesData.splice(index + 1, 1)[0];
          return (
            <DoubleTileController {...tile} secondTile={{ ...secondTile }} key={key} />);
        }
        // hero tile size
        if (tile.size === 3) {
          return (<HeroTileView {...tile} key={key} />);
        }
        switch (tile.type) {
          case 'newsletter':
            return (<NewsletterTileView {...tile} key={key} />);
          case 'shop':
            return (<ShopTileView {...tile} key={key} />);
          default:
            return (<TileController {...tile} key={key} />);
        }
      },
    );
  }

  static fillerTile(index, diff, currentTiles) {
    for (let i = index; i < currentTiles.length; i += 1) {
      if (currentTiles[i].size <= diff && !currentTiles[i].sticky && currentTiles[i].size < 3) {
        const filler = currentTiles.splice(i, 1)[0];
        currentTiles.splice(index, 0, filler);
        return currentTiles;
      }
    }
    return currentTiles;
  }

  constructor(props) {
    super(props);

    this.state = {
      rowSum: 3,
      resizeId: 0,
    };

    this.reRenderTiles = this.reRenderTiles.bind(this);
  }

  componentWillMount() {
    this.setRowSum();
  }

  componentDidMount() {
    window.addEventListener('resize', this.reRenderTiles);
  }

  componentWillReceiveProps() {
    clearTimeout(this.state.resizeId);
    window.removeEventListener('resize', this.reRenderTiles);
    window.addEventListener('resize', this.reRenderTiles);
  }

  componentWillUnmount() {
    clearTimeout(this.state.resizeId);
    window.removeEventListener('resize', this.reRenderTiles);
  }

  setRowSum() {
    const breakpoint = getBreakpoint();
    let newSum;
    switch (breakpoint) {
      case 'sm':
        newSum = 2;
        break;
      case 'md':
        newSum = 2;
        break;
      case 'lg':
        newSum = 3;
        break;
      case 'xl':
        newSum = 3;
        break;
      case 'xxl':
        newSum = 4;
        break;
      case 'xxxl':
        newSum = 6;
        break;
      default:
        newSum = 4;
    }
    if (newSum !== this.state.rowSum) {
      this.setState({
        rowSum: newSum,
      });
    }
  }

  sortTiles(tilesData) {
    let rowSum = 0;
    let currentTiles = [...tilesData];

    for (let i = 0; i < currentTiles.length; i += 1) {
      const tile = currentTiles[i];
      let size = tile.size;

      if (tile.size === 3) {
        size = this.state.rowSum;
      }
      if (size + rowSum > this.state.rowSum) {
        const diff = this.state.rowSum - rowSum;
        currentTiles = TileContainerController.fillerTile(i, diff, currentTiles);
        rowSum += currentTiles[i].size;
      } else if (size === 0.5) {
        currentTiles = TileContainerController.fillerTile(i + 1, 0.5, currentTiles);
        rowSum += 1;
        i += 1;
      } else {
        rowSum += size;
      }

      if (rowSum === this.state.rowSum) {
        rowSum = 0;
      }
    }
    return currentTiles;
  }

  reRenderTiles() {
    clearTimeout(this.state.resizeId);
    this.setState({
      resizeId: setTimeout(() => {
        this.setRowSum();
        this.sortTiles(this.props.tilesData);
      }, 500),
    });
  }

  render() {
    const tiles = TileContainerController.makeTileObjects(this.sortTiles(this.props.tilesData));

    return (
      <TileContainerView {...this.props} tiles={tiles} />
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.tilesState.page,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchTiles }, dispatch);
}

TileContainerController.propTypes = {
  tilesData: PropTypes.arrayOf(PropTypes.shape({
    headline: PropTypes.string,
    subline: PropTypes.string,
    image: PropTypes.oneOfType([
      PropTypes.shape({
        xxl: PropTypes.string,
        xl: PropTypes.string,
        lg: PropTypes.string,
        md: PropTypes.string,
        sm: PropTypes.string,
        default: PropTypes.string,
      }), PropTypes.array,
    ]),
  })),
  fetchTiles: PropTypes.func.isRequired,
};

TileContainerController.defaultProps = {
  tilesData: [
    {
      headline: '',
      subline: '',
      image: {},
    },
  ],
};

export default connect(mapStateToProps, mapDispatchToProps)(TileContainerController);



// WEBPACK FOOTER //
// ./frontend/js/Components/Tiles/TileContainer/TileContainerController.jsx